import { Button, Checkbox, Col, Divider, Row, Typography } from "antd";
import React, { useState } from "react";
import { formatDateInMMDDYYYY } from "../../../helpers/date";
import { orderStatusEnums } from "../../../helpers/enums";
import OrderDropDown from "../order-items/OrderDropDown";
import ChatIcon from "./../../../graphics/svgs/chatIcon.svg";
import PrintIcon from "./../../../graphics/svgs/printIcon.svg";
import RefundConfirmationModal from "../../../modals/RefundConfirmationModal";
import "./dashboardcard.css";
const DashboardItemCard: React.FC<IDashboardOrderMobileCard> = ({ order }) => {
  const { shippingDetails } = order;
  const [showRefundModal, setShowRefundModal] = useState<boolean>(false);
  const isRefunded = order.processingDetails.orderStatus === orderStatusEnums.REFUNDED;

  const handleOpenPdf = (pdfUrl: string) => {
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.target = "_blank"; // Opens in a new tab
    link.rel = "noopener noreferrer";
    link.click();
  };
  return (
    <>
      {showRefundModal && (
        <RefundConfirmationModal
          show={showRefundModal}
          handleClose={(e) => setShowRefundModal(false)}
          order={order}
        />
      )}
      <div className="dashboard-item-card">
        <Row className="dashboard-card-single-item-container">
          <Col className="checkbox-dashboard-item" span={24}>
            {order.isFirstOrder === true && (
              <Typography className="first-order-tag">
                1st time order
              </Typography>
            )}
            {/* <Typography className="first-order-tag">1st time order</Typography> */}
            <Checkbox />
            <img
              src={PrintIcon}
              onClick={(e) => {
                if (
                  order.processingDetails.orderStatus ===
                    orderStatusEnums.ASSIGNED_RX &&
                  order.processingDetails.shippingLabel !== null
                ) {
                  handleOpenPdf(order.processingDetails.shippingLabel);
                }
              }}
              style={{ width: "25px", cursor: "pointer" }}
            />
            <img src={ChatIcon} style={{ width: "25px", cursor: "pointer" }} />
            {/* <img
              src={ThreeDotsHrz}
              style={{ width: "25px", cursor: "pointer" }}
            /> */}
            <OrderDropDown order={order} />
          </Col>
          <Col span={24}>
            <Typography className="dashboard-card-item-title">
              Customer
            </Typography>

            <Typography className="users-table-customer-name">
              {order.user.firstName} {order.user.lastName}
            </Typography>
            <Typography className="users-table-customer-phone">
              {order.user.phoneNumber || ""}
            </Typography>
            <Typography className="users-table-customer-phone">
              {order.user.email}
            </Typography>
            <Divider />
          </Col>

          <Col span={24}>
            <Typography className="dashboard-card-item-title">
              Address
            </Typography>

            <Typography className="users-table-generic-label">
              <Typography className="users-table-generic-label">
                {`${shippingDetails.address.street1}${
                  shippingDetails.address.street2
                    ? `, ${shippingDetails.address.street2}`
                    : ""
                }, ${shippingDetails.address.city}, ${
                  shippingDetails.address.state
                } ${shippingDetails.address.zipCode}`}
              </Typography>
            </Typography>
            <Divider />
          </Col>
          <Col span={24}>
            <Typography className="dashboard-card-item-title">
              Pain level & Order date
            </Typography>

            <Typography className="users-table-generic-label">
              {order.painProfile.painRating}{" "}
              {formatDateInMMDDYYYY(order.createdAt, true)}
            </Typography>
            <Divider />
          </Col>
          <Col span={24}>
            <Typography className="dashboard-card-item-title">
              Order # & Status
            </Typography>

            <Typography className="users-table-generic-label">
              # {order.processingDetails.orderNumber}
            </Typography>

            <Typography
              className="order-prescribed-tag"
              style={{
                color: isRefunded ? "#ff4d4f" : undefined,
                fontWeight: isRefunded ? "600" : undefined,
              }}
            >
              {" "}
              {order.processingDetails.orderStatus}
            </Typography>
            {isRefunded && (
              <Typography
                style={{
                  color: "#ff4d4f",
                  fontSize: "14px",
                  fontWeight: "600",
                  marginTop: "8px",
                }}
              >
                Refunded
              </Typography>
            )}
            <Divider />
          </Col>
          <Col span={24}>
            <Typography className="dashboard-card-item-title">
              Prescribed formula
            </Typography>

            <Typography className="users-table-generic-label">
              {order.processingDetails.formulaAssigned !== null
                ? `${order.processingDetails.formulaAssigned?.activeIngredients},${order.processingDetails.formulaAssigned?.creamBase}`
                : "---"}
            </Typography>
          </Col>
          {!isRefunded && (
            <Col span={24} style={{ marginTop: "16px" }}>
              <Button
                type="primary"
                danger
                onClick={() => setShowRefundModal(true)}
                style={{
                  width: "100%",
                  backgroundColor: "#ff4d4f",
                  borderColor: "#ff4d4f",
                }}
              >
                Refund Order
              </Button>
            </Col>
          )}
        </Row>
      </div>
    </>
  );
};

export default DashboardItemCard;
